import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane, Button } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { fetchTitleById } from "../../api/titleService";
import { fetchPeriodicalTitleById } from "../../api/periodicalLibraryService";
import { TitleDetail } from "./TitleDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
export var TitleDetailPage = function (_a) {
    var type = _a.type;
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _b = useQuery(["title", type, id], function () {
        return type === "PERIODICAL"
            ? fetchPeriodicalTitleById(ky, id)
            : fetchTitleById(ky, id);
    }, {
        enabled: !!id,
    }), title = _b.data, isLoading = _b.isLoading, isError = _b.isError, error = _b.error;
    var handleBackToList = function () {
        history.goBack();
    };
    if (!id) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.titles.detail.pane.title",
                }) },
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.titles.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.loading" }))));
    }
    if (isError || !title) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-legaldeposits.titles.detail.pane.title",
                }) },
                React.createElement("p", null, (error === null || error === void 0 ? void 0 : error.message) || (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.error.title.not.found" }))),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })))));
    }
    var displayName = title.title ||
        formatMessage({ id: "ui-br-legaldeposits.titles.detail.pane.title" });
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: displayName, firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.back" })) },
            React.createElement(TitleDetail, { title: title }))));
};
